import Crafting from '../../../../wttrpg/Crafting';

export default {
    DWARVEN_POLE_HAMMER: {
        name: 'Dwarven Pole Hammer',
        DC: 25,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 6 },
            { component: Crafting.MAHAKAMAN_STEEL.item, amount: 3 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 3 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
            { component: Crafting.OGRE_WAX.item, amount: 1 },
        ],
        investment: 624,
        cost: 1248,
    },
    ELVEN_WALKING_STAFF: {
        name: 'Elven Walking Staff',
        DC: 25,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 6 },
            { component: Crafting.GOLD.item, amount: 2 },
            { component: Crafting.ESTER_GREASE.item, amount: 6 },
            { component: Crafting.WOLF_HIDE.item, amount: 2 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.SILK.item, amount: 1 },
            { component: Crafting.FIFTH_ESSENCE.item, amount: 3 },
            { component: Crafting.GEMSTONE.item, amount: 1 },
        ],
        investment: 735,
        cost: 1470,
    },
    ELVEN_ZEFHAR: {
        name: 'Elven Zefhar',
        DC: 25,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 8 },
            { component: Crafting.THREAD.item, amount: 8 },
            { component: Crafting.OGRE_WAX.item, amount: 8 },
            { component: Crafting.FIFTH_ESSENCE.item, amount: 2 },
            { component: Crafting.LEATHER.item, amount: 2 },
            { component: Crafting.FEATHERS.item, amount: 4 },
            { component: Crafting.BEAST_BONES.item, amount: 4 },
            { component: Crafting.DARK_STEEL.item, amount: 2 },
            { component: Crafting.ESTER_GREASE.item, amount: 8 },
            { component: Crafting.ETCHING_ACID.item, amount: 6 },
        ],
        investment: 830,
        cost: 1660,
    },
    GNOMISH_BLACK_AXE: {
        name: 'Gnomish Black Axe',
        DC: 25,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 4 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.DIMERITIUM.item, amount: 1 },
            { component: Crafting.DARK_STEEL.item, amount: 3 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
            { component: Crafting.OGRE_WAX.item, amount: 1 },
        ],
        investment: 688,
        cost: 1376,
    },
    GNOMISH_GWYHYR: {
        name: 'Gnomish Gwyhyr',
        DC: 25,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 2 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.DIMERITIUM.item, amount: 2 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 3 },
            { component: Crafting.ESTER_GREASE.item, amount: 4 },
            { component: Crafting.DARKENING_OIL.item, amount: 1 },
        ],
        investment: 814,
        cost: 1628,
    },
    GNOMISH_HAND_CROSSBOW: {
        name: 'Gnomish Hand Crossbow',
        DC: 25,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 2 },
            { component: Crafting.THREAD.item, amount: 4 },
            { component: Crafting.WAX.item, amount: 2 },
            { component: Crafting.RESIN.item, amount: 2 },
            { component: Crafting.DARK_STEEL.item, amount: 2 },
            { component: Crafting.DARKENING_OIL.item, amount: 2 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 1 },
        ],
        investment: 317,
        cost: 634,
    },
    METEORITE_CHAIN_MACE: {
        name: 'Meteorite Chain Mace',
        DC: 25,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.METEORITE.item, amount: 5 },
            { component: Crafting.HARDENED_TIMBER.item, amount: 1 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 1 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
        ],
        investment: 676,
        cost: 1352,
    },
    TIR_TOCHAIR_BLADE: {
        name: 'Tir Tochair Blade',
        DC: 26,
        craftTime: '13 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 2 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.MAHAKAMAN_DIMERITIUM.item, amount: 2 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 2 },
            { component: Crafting.DRACONID_LEATHER.item, amount: 1 },
        ],
        investment: 888,
        cost: 1776,
    },
}

// {
//     name: '',
//     DC: 25,
//     craftTime: '13 Hours',
//     ingredients: [
//         { component: Crafting..item, amount: 1 },
//         { component: Crafting..item, amount: 2 },
//     ],
//     investment: ,
//     cost: ,
// },